import { Expense } from "@finway-group/shared/lib/models"
import type { RenderExpandIconProps } from "rc-table/es/interface"
import React from "react"
import { CornerDownRightArrowIcon } from "~Components/icons/CornerDownRightArrowIcon"
import { ExpandableListItemIcon } from "~Components/icons/ExpandableListItemIcon"
import { checkBelongsToAFolder, isFolderExpense } from "~Shared/utils/expense.utils"

export const ExpandTripFolderTableIcon = ({ props }: { props: RenderExpandIconProps<Expense> }) => {
    const { record, expanded, onExpand } = props
    // if row has a children, show circle icon
    if (isFolderExpense(record) && record.children?.length > 0) {
        return (
            <div
                role="button"
                onClick={(e) => {
                    e.stopPropagation()
                    onExpand(record, e)
                }}
            >
                <ExpandableListItemIcon expanded={expanded} />
            </div>
        )
    }
    if (checkBelongsToAFolder(record)) {
        // if the category has a parent
        return <CornerDownRightArrowIcon />
    }
    return <></>
}
